export * from './civilite.model';
export * from './bac.model';
export * from './mention.model';
export * from './pays.model';
export * from './commune.model';
export * from './departement.model';
export * from './composant.model';
export * from './discipline.model';
export * from './rne.model';
export * from './type-composant.model';
export * from './type-formation.model';
export * from './type-etablissement.model';
export * from './niveau-acces-diplome.model';
export * from './g-mention.model';
export * from './grade-universitaire.model';
export * from './grhum.service';
export * from './lien.model';
export * from './structure.model';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/index.ts